import React, { useState, useEffect } from 'react'
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { thirdparty } from '../../'
import SEO from "../Seo";
import { ToastContainer } from "react-toastify";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";

import TableComponent from './TableComponent'
import { formatDate } from '../../utils/utils'

const homesamplecollection = () => {
    const [fatchData, setFatchdata] = useState([]);

    const fetchData = async () => {
        try {
            const response = await thirdparty.get("/home_sample_collections");
            if (response.status === 200) {
                setFatchdata(response.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    }

    useEffect(() => {
        fetchData();
    }, [])

    const columns = [
        { header: "#", accessor: (_, index) => index + 1 },
        { header: "Name", accessor: "name" },
        { header: "Email", accessor: "email" },
        { header: "Phone", accessor: "phone" },
        { header: "Address", accessor: "address" },
        { header: "Prescription", accessor: (item) => (`<a href=${item.user_file} target="_blank">View</a>`) },
        { header: "Requested at", accessor: (item) => formatDate(item.created_at) }
    ];

    return (
        <div className="fixed-left">
            <SEO
                title="Home Sample Collection "
                description="Home Sample Collection - United Hospital"
                pathSlug="/admin/user-log"
                keywords="Home Sample Collection"
            />
            <div id="wrapper">
                <Route component={LeftSidebar} />
                <div className="content-page">
                    <div className="content">
                        <Route component={TopHeader} />
                        <div className="page-content-wrapper ">
                            <TableComponent title="Home Sample Collection" data={fatchData} columns={columns} />
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer autoClose={5000} />
        </div>
    )
}

export default homesamplecollection


// WEBPACK FOOTER //
// ./src/component/admin/homesamplecollection.js